module.exports = __webpack_public_path__ + "img/back_arrow.18048cc6.svg";